import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs/internal/Observable";
import { map } from "rxjs/operators";
import { isNullOrUndefined } from "util";
import { LoginRQT } from "../models/user-LoginRQT";

import { UserInterfaceRQT } from "../models/user-interfaceRQT";
import { UserInterfaceRPT } from "../models/user-interfaceRPT";
import { TermCond } from "app/models/termcond";
import { UsuarioRQT } from "app/models/UsuarioRQT";
import { actContraseniaRQT} from "../models/user_actContraseniaRQT";
import { actContraseniaRPT} from "../models/user_actContraseniaRPT";

import { RepStockCSURQT, RepStockCSURQTDet} from "../models/rep_stockCsuRqt";
import { RegistroStockCSU, RegistroStockCSUDet} from "../models/reg_stockcsu";


import { RepDiasLibresRQT} from "../models/rep_diaslibresRQT"
import { RepDiasLibresRPT} from "../models/rep_diaslibresRPT"


import { RepDireccionamientoRQT} from "../models/rep_direccionamientoRQT"
import { RepDireccionamientoRPT} from "../models/rep_direccionamientoRPT"

import { Suscripcion } from "app/models/user_suscripcion";
import { Notificaciones} from "../models/notificacion";
import { LoginToken } from "app/models/user-LoginToken";

@Injectable({
  providedIn: "root"
})
export class AuthService {
  constructor(private http: HttpClient) {}
  headers: HttpHeaders = new HttpHeaders(
      {
        "Content-Type": "application/json"
      }
    );

  loginuser(usuario: string, password: string): Observable<any> {
    const url_api =`/ContransAPI/api/login/${usuario}/${password}/wddwdw/dwwddw/asasas`;
    return this.http
      .get<UserInterfaceRPT>(
        url_api, 
        { headers: this.headers }
        )
      .pipe(map(data => data));
  }

  getIp()
  {
    this.http.get<{ip:string}>('https://jsonip.com')
    .subscribe( data => {
      localStorage.setItem("DireccionIP", data.ip);
    })
  }

  loginusuario(login: LoginRQT ): Observable<any> 
  {
    const url_api =`/ContransAPI/api/loginSeg`;
    return this.http
      .post<UserInterfaceRPT>(
        url_api, login, { headers: this.headers })
      .pipe(map(data => data));
  }

  tokenusuario(login: LoginToken ): Observable<any> 
  {
    const url_api =`/ContransAPI/api/logintoken`;
    return this.http
      .post<UserInterfaceRPT>(
        url_api, login, { headers: this.headers })
      .pipe(map(data => data));
  }

  getToken() {
    return localStorage.getItem("accessToken");
  }

  getCurrentUser(): UserInterfaceRPT {
    let user_string = localStorage.getItem("currentUser");
    if (!isNullOrUndefined(user_string)) {
      let user: UserInterfaceRPT = JSON.parse(user_string);
      return user;
    } else {
      return null;
    }
  }

  
  
  actContrasenia(reqactContra: actContraseniaRQT): Observable<any> 
  {
    const url_api =`/ContransAPI/api/actualizarContrasena`;    
    return this.http
      .post<actContraseniaRPT>(
        url_api, reqactContra, { headers: this.headers })
      .pipe(map(data => data));
  }

  
  getRegStockCSU(reqstockcsu:RepStockCSURQT): Observable<any> 
  {
    const url_api =`/ContransAPI/api/consultarStockCSReg`;    
    return this.http
      .post<RegistroStockCSU>(
        url_api, reqstockcsu, { headers: this.headers })
      .pipe(map(data => data));
  }

  
  getDiasLibres(reqdiaslibres:RepDiasLibresRQT): Observable<any> 
  {
    const url_api =`/ContransAPI/api/diaslibresrpt`;    
    return this.http
      .post<RepDiasLibresRPT>(
        url_api, reqdiaslibres, { headers: this.headers })
      .pipe(map(data => data));
  }

  
  getDireccionamiento(reqdirecc:RepDireccionamientoRQT): Observable<any> 
  {
    const url_api =`/ContransAPI/api/consultardireccionamiento`;    
    return this.http
      .post<RepDireccionamientoRPT>(
        url_api, reqdirecc, { headers: this.headers })
      .pipe(map(data => data));
  }
  
  getRegStockCSUDet(reqstockcsudet:RepStockCSURQTDet): Observable<any> 
  {
    const url_api =`/ContransAPI/api/consultarStockCSRegDetalle`;    
    return this.http
      .post<RegistroStockCSUDet>(
        url_api, reqstockcsudet, { headers: this.headers })
      .pipe(map(data => data));
  }

  recuperarContrasena(login: LoginRQT ): Observable<any> 
  {
    const url_api =`/ContransAPI/api/recuperarContrasena`;
    return this.http
      .post<UserInterfaceRPT>(
        url_api, login, { headers: this.headers })
      .pipe(map(data => data));
  }

  getTyC(): Observable<any>
  {
    const url_api =`/ContransAPI/api/texto`;
    return this.http.post<TermCond>(url_api,{ "IdTexto": 1 },{ headers: this.headers })
    .pipe(map(data => data));
  }

  setTyCUsuario(IDUserParam:string)
  {
    let objUser : UsuarioRQT = {
      IDUser : Number.parseInt(IDUserParam),
      Cargo : "",
      Celular: "",
      Email : "",
      RolEmpUsuaCodigoDefault : 0,
      Telefono : ""
    }
    const url_api =`/ContransAPI/api/acepTermCond`;

    return this.http.post<Suscripcion>(url_api,objUser,{ headers: this.headers })
    .pipe(map(data => data));
    
  }

  
  getNotificaciones(): Observable<any> 
  {
    const url_api =`/ContransAPI/api/avisos`;    
    return this.http
      .post<Notificaciones>(
        url_api, { headers: this.headers })
      .pipe(map(data => data));
  }



}
